@if (visible()) {
  <div data-testid="tos-modal"
       class="fixed inset-0 z-[90] flex items-center justify-center bg-black/70 backdrop-blur-sm">
    <div class="max-w-lg w-full mx-4 p-6 rounded-xl border border-[var(--nexus-border)] bg-[var(--nexus-surface)] shadow-2xl">
      <h2 class="font-mono text-sm uppercase tracking-wider text-[var(--nexus-cyan)] mb-1">
        Terms of Service &amp; Privacy Policy
      </h2>
      <p class="text-xs text-[var(--nexus-text-muted)] mb-4">
        Please read and accept before continuing.
      </p>

      <div class="h-48 overflow-y-auto mb-4 rounded-lg bg-[var(--nexus-panel)] p-4 text-xs text-[var(--nexus-text-muted)] leading-relaxed">
        <p class="mb-2 font-semibold text-[var(--nexus-text)]">Westyx Nexus - Terms of Service (Beta)</p>
        <p class="mb-2">By using Westyx Nexus during the beta period you agree to the following terms:</p>
        <p class="mb-2">1. <strong>Beta nature.</strong> The service is provided "as-is" during the beta. Features may change or be removed without notice.</p>
        <p class="mb-2">2. <strong>Data.</strong> We store only data you explicitly upload. We do not sell your data to third parties.</p>
        <p class="mb-2">3. <strong>GDPR.</strong> If you are an EU resident, you have the right to access, rectify, or delete your personal data at any time by contacting support&#64;westyx.dev.</p>
        <p class="mb-2">4. <strong>Security.</strong> You are responsible for keeping your API keys confidential. Immediately rotate any key you believe has been compromised.</p>
        <p class="mb-2">5. <strong>Fair use.</strong> Do not use the service in a way that degrades it for other users.</p>
        <p>Full terms available at
          <a href="https://westyx.dev/terms" target="_blank" rel="noopener noreferrer"
             class="text-[var(--nexus-cyan)] underline hover:brightness-125">
            westyx.dev/terms
          </a>.
        </p>
      </div>

      <input type="checkbox" id="tos-accept" class="nx-toggle"
             [checked]="checkboxChecked()"
             (change)="checkboxChecked.set($any($event.target).checked)" />
      <label for="tos-accept" class="flex items-center gap-3 mb-5 cursor-pointer select-none">
        <span class="nx-toggle-track"><span class="nx-toggle-thumb"></span></span>
        <span class="text-sm text-[var(--nexus-text)]">
          I have read and agree to the Terms of Service and Privacy Policy.
        </span>
      </label>

      <button
        type="button"
        class="nx-btn-primary w-full py-3"
        [disabled]="!checkboxChecked()"
        (click)="accept()">
        Continue to Westyx Nexus &rarr;
      </button>
    </div>
  </div>
}
